export default [
  {
    text: 'Logo Sponsorship title',
    value: 'name',
  },
  {
    text: 'Merchant',
    value: 'merchant.name',
    apiSort: 'pepper_merchants.name',
  },
  {
    text: 'Category',
    value: 'categories',
    apiSort: 'pepper_categories.name',
  },
  {
    text: 'Platform',
    value: 'country.platform',
    apiSort: 'country',
  },
  {
    text: 'Dates',
    value: 'dates',
    apiSort: 'start_date',
  },
  {
    text: 'Status',
    value: 'status',
    width: '10%',
  },
];
